import { observable, action, makeObservable } from 'mobx'
import { selectionTypes } from 'constants.js'
import api from 'api.js'

class BulkIsochrone {
  @observable travelTime = 30
  @observable modeOfTransportation = 'Driving'
  @observable invalid = observable.map()
  @observable enableSubmit = true
  @observable additional_info = []

  constructor () {
    makeObservable(this)
  }

  get selection () {
    return {
      item: this,
      type: selectionTypes.BULK_ISOCHRONE,
      data: { focusedInteraction: true }
    }
  }

  validate () {
    this.invalid.clear()
    if (this.travelTime < 1 || this.travelTime > 60) {
      this.invalid.set('travelTime', 'Please enter a value between 1 and 60')
      return false
    }
    return true
  }

  @action async add (targetGroupId, dsYear, dsName) {
    if (this.validate()) {
      const result = await api.postBulkIsochrone({
        target_group_id: targetGroupId,
        travel_time: this.travelTime,
        mode: this.modeOfTransportation,
        ds_year: dsYear,
        ds_name: dsName
      })
      return result.data
    }
    return null
  }
}

export default BulkIsochrone
